import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

// simple login logic
let token = localStorage.getItem('token')
if (token) {
  Vue.axios.defaults.headers.common = {
    'X-Token': token
  }
}

export const projectPhases = [
  { id: 1, name: 'Open', description: '', color: 'success' },
  { id: 2, name: 'Specified', description: '', color: 'info' },
  { id: 3, name: 'Waiting', description: '', color: 'warning' },
  { id: 4, name: 'Approved', description: '', color: 'primary' },
  { id: 5, name: 'Waiting', description: '', color: 'secondary' },
  { id: 6, name: 'Waiting', description: '', color: 'success' },
  { id: 7, name: 'In progress', description: '', color: 'warning' },
  { id: 8, name: 'In verification', description: '', color: 'info' },
  { id: 9, name: 'Verified', description: '', color: 'primary' },
  { id: 10, name: 'Closed', description: '', color: 'danger' },
  { id: 11, name: 'Canceled', description: '', color: 'danger' }
]

export default new Vuex.Store({
  state: {
    user: {
      id: localStorage.getItem('userId')
    },
    users: [],
    jwt: token,
    projects: [],
    project: null,
    phases: projectPhases
  },
  getters: {
    isLoggedIn: state => {
      return state.jwt !== null
    },
    getUserById: state => id => state.users.find(u => u.id === id),
    getUserByUsername: state => username => state.users.find(u => u.username === username),
    isAdmin: state => {
      return state.user && state.user.role === 'Admin'
    },
    isPortfolioManager: state => {
      return state.user && state.user.role === 'Portfolio Manager'
    },
    isManager: state => {
      return state.user && state.user.role === 'Manager'
    },
    project: state => {
      return state.project
    },
    user: state => {
      return state.user
    },
    users: state => {
      return state.users
    },
    phases: state => {
      return state.phases
    },
    getAllPhasesIds: state => {
      return state.phases.map(phase => phase.id)
    },
    projects: state => {
      return state.projects
    }
  },
  mutations: {
    LOGGED_IN (state, { token, userId }) {
      state.user = {
        id: userId
      }
      localStorage.setItem('token', token)
      localStorage.setItem('userId', userId)
      state.jwt = token
      Vue.axios.defaults.headers.common = {
        'X-Token': token
      }
      router.push('/')
      this.dispatch('loadUsers')
    },
    PROJECTS_LOADED (state, data) {
      state.projects = data
    },
    PROJECT_LOADED (state, data) {
      state.project = data
    },
    USER (state, data) {
      state.user = { ...data, ...state.user }
    },
    USERS_LOADED (state, data) {
      state.users = data
    },
    LOGOUT (state) {
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      state.jwt = null
      if (router.currentRoute.fullPath !== 'login') {
        router.push('/login')
      }
    }
  },
  actions: {
    login ({ commit }, credentials) {
      Vue.axios.post(Vue.prototype.$serverAddr + '/login', credentials).then((response) => {
        commit('LOGGED_IN', response.data)
        this.dispatch('loadUser', response.data.userId)
      })
    },
    logout ({ commit }) {
      commit('LOGOUT')
    },
    loadProjects ({ commit }, params) {
      Vue.axios.get(Vue.prototype.$serverAddr + '/project', { params: params }).then((response) => {
        commit('PROJECTS_LOADED', response.data)
      })
    },
    loadProject ({ commit }, id) {
      Vue.axios.get(Vue.prototype.$serverAddr + '/project/' + id).then((response) => {
        if (response.data[0].intent.length === 0) {
          response.data[0].intent.push({
            id: '0',
            long_summary: '',
            name: '',
            short_summary: ''
          })
        }

        if (response.data[0].matrix.length === 0) {
          response.data[0].matrix.push({
            assumption: '',
            goals: '',
            id: '',
            indicators: '',
            sources: ''
          })
        }
        commit('PROJECT_LOADED', response.data[0])
      })
    },
    addProject ({ commit }, data) {
      Vue.axios.post(Vue.prototype.$serverAddr + '/project', data).then((response) => {
        router.push('/project/' + response.data)
      })
    },
    loadUsers ({ commit }) {
      Vue.axios.get(Vue.prototype.$serverAddr + '/user', {
        params: {
          page: '0',
          perPage: '1000',
          sortBy: 'id',
          desc: ''
        }
      }).then((response) => {
        commit('USERS_LOADED', response.data.items)
      })
    },
    loadUser ({ commit }, id) {
      if (id) {
        Vue.axios.get(Vue.prototype.$serverAddr + '/user/' + id).then((response) => {
          response.data.id = id
          commit('USER', response.data[0])
        })
      }
    }
  }
})
